import { KEYS_TO_RETAIN_ON_LOGOUT } from "@/constants/local-storage-keys";
import { removeToken } from "./token-utils";

export const DISALLOWED_REDIRECTS = [
  "login",
  "reset",
  "forgot",
  "sign-up",
  "user-info",
  "verify-email",
  "registration-complete",
  "denied",
  "account-deleted",
  "sharing",
];

export const SESSION_EXPIRED = "expired";
export const ACCESS_DENIED = "AccessDenied";

export const clearUserState = () => {
  Object.keys(localStorage).forEach((key) => {
    if (
      !KEYS_TO_RETAIN_ON_LOGOUT.some((retentionKey) =>
        key.startsWith(retentionKey),
      )
    ) {
      localStorage.removeItem(key);
    }
  });
  removeToken();
};
